import { Box, Container, Heading, Image, Spinner, Text, VStack } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import packageInfo from "../../package.json";

const scaleUp = keyframes`
  0%   { transform: scale(1); }
  100% { transform: scale(1.15); }   
`;

const SplashScreen = () => {
  return (
    <Container fluid width={"100vw"} height={"100vh"} p={0} position={"absolute"} zIndex={10000} top={0} left={0} bg={"white"}>
      <Box height="100vh" width="100vw" display="flex" alignItems="center" justifyContent="center" bg="#F8FAFC">
        <VStack spacing={4}>
          <VStack spacing={4} animation={`${scaleUp} 1.5s forwards`}>
            <Image userSelect={"none"} draggable={false} src="/assets/image/gatik-logo.png" alt="Logo" boxSize="300px" />
            <Heading fontSize="7xl" fontWeight="medium" color="gray.700" userSelect={"none"}>
              Gatik Horizon
            </Heading>
          </VStack>
          <Spinner mt={"60px"} color="gray.700" size="xl" borderWidth={"5px"} />
          <Text color={"blackAlpha.400"}>V {packageInfo.version}</Text>
        </VStack>
      </Box>
    </Container>
  );
};

export default SplashScreen;
